import { render, staticRenderFns } from "./emailAstec.vue?vue&type=template&id=10c2964b"
import script from "./emailAstec.vue?vue&type=script&lang=js"
export * from "./emailAstec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports